/** Detect dental / oral specialty for Dental OP workspace gating. */

const DENTAL_KEYWORDS = [
  'dental',
  'dentist',
  'dentistry',
  'oral',
  'orthodont',
  'pedodont',
  'periodont',
  'endodont',
  'prosthodont',
  'oral surgery',
  'maxillofacial',
  'oms',
];

export function isDentalSpecialty(specialtyOrText) {
  const s = String(specialtyOrText || '').toLowerCase();
  if (!s.trim()) return false;
  return DENTAL_KEYWORDS.some((k) => s.includes(k));
}

export function doctorHasDentalWorkspace(user, hospitalEmrSettings) {
  if (!user) return false;
  if (hospitalEmrSettings?.enableDentalChart === true) return true;
  if (user.enableDentalOp === true || user.dentalWorkspace === true) return true;
  if (isDentalSpecialty(user.specialty) || isDentalSpecialty(user.department)) return true;
  return false;
}

export const DENTAL_SPECIALTY_OPTIONS = [
  'Dental / Oral Health',
  'General Dentistry',
  'Orthodontics',
  'Pedodontics',
  'Periodontics',
  'Endodontics',
  'Prosthodontics',
  'Oral & Maxillofacial Surgery',
];
